import type { TEffectCallback } from './effect'

export enum EControlEventName {
  MULTI_TOUCH = 'multi_touch',
  MOVE = 'move',
  CONTROL_RECT_RESIZE = 'control_rect_resize',
  PRESET_KEYBOARD_DOWN = 'preset_keyboard_down',
  PRESET_KEYBOARD_UP = 'preset_keyboard_up',
  KEYBOARD_DOWN = 'keyboard_down',
  KEYBOARD_UP = 'keyboard_up',
  KEYBOARD_DATA_UPDATE = 'keyboard_data_update',
  TOGGLE_SCREEN_FOLLOW_SCREEN_STATUS = 'toggle_screen_follow_screen_status'
}

export enum EControlTouchType {
  DOWN = 0,
  UP = 2
}

export enum EControlSystemKey {
  HOME = '0',
  MENU = '1',
  BACK = '2',
  VOLUME_ADD = '3',
  VOLUME_SUB = '4',
  DELETE = '5',
  ENTER = '6'
}

export type TInputEvent = Event & { isComposing: boolean, data: string }

export enum ECompassDirection {
  UP,
  LEFT,
  DOWN,
  RIGHT
}

export enum EPresetKeyboardAction {
  TOUCH,
  COMPASS,
  ZOOM,
  ROTATION,
}

export enum ELocusStatus {
  DOWN,
  MOVE,
  UP,
  MOVE_END_UP,
  DOWN_IN_MOVE,
  UP_IN_MOVE
}

interface ICommonKeyboardInteractiveBlock {
  width: number,
  height: number,
  x: number,
  y: number,
  name: string | Record<ECompassDirection, string>,
  zIndex: number,
  type: EPresetKeyboardAction,
}

export interface IPresetKeyboardInteractiveBlock extends ICommonKeyboardInteractiveBlock {
  code: Array<string>,
}

export type TPresetKeyboardItem = {
  patch: EPresetKeyboardAction,
  interactive: string,
  direction?: ECompassDirection,
  composition?: Array<string>
  isCompose?: boolean
}

export interface IPresetKeyboardMap {
  interactive: Record<string, IPresetKeyboardInteractiveBlock>,
  logic: Record<string, Array<TPresetKeyboardItem>>
}

export type IControlEffectCallback = <T>(callback: TEffectCallback<T>, effectList: Array<EControlEventName>, needEventName?: boolean) => void

export interface IControlStateInfo { isHorizontal: boolean, isInputStatus?: boolean, configKeyboard?: IPresetKeyboardMap, isFreezeControl?: boolean }

export type TLocusStateInfo = {
  x: number,
  y: number,
  status: ELocusStatus
}

export type TCompassFivePointsData = Record<'centerX' | 'centerY' | 'leftX' | 'leftY' | 'rightX' | 'rightY' | 'topX' | 'topY' | 'bottomX' | 'bottomY', number>;

export type TEditControlInteractive = {
  x?: number
  y?: number
  width?: number
  height?: number
  code?: string[]
  name?: string | Record<ECompassDirection, string>
  direction?: ECompassDirection
}

export enum EGameOrientation {
  PORTRAIT = 0,
  LANDSCAPE = 1
}
